import { render, staticRenderFns } from "./GuiasAereasComponent.vue?vue&type=template&id=12bed2f8&"
import script from "./GuiasAereasComponent.vue?vue&type=script&lang=js&"
export * from "./GuiasAereasComponent.vue?vue&type=script&lang=js&"
import style0 from "./GuiasAereasComponent.vue?vue&type=style&index=0&id=12bed2f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports